import React, { ReactNode } from "react";
import styled from "styled-components";
import GatsbyImage, { FluidObject } from "gatsby-image";

type ImgVerticalAlign = "middle" | "top";

interface BackgroundImageProps {
  fluid?: FluidObject;
  children: ReactNode;
  imgVerticalAlign?: ImgVerticalAlign;
}

export function BackgroundImage({
  fluid,
  children,
  imgVerticalAlign = "middle",
}: BackgroundImageProps) {
  const imgStyle = getImgStyle(imgVerticalAlign);

  return (
    <Container>
      {fluid ? (
        <GatsbyImage
          style={imgStyle}
          fluid={fluid}
          loading="eager"
          fadeIn={false}
          alt=""
        />
      ) : (
        <GrayBackground />
      )}
      {children}
    </Container>
  );
}

function getImgStyle(imgVerticalAlign: ImgVerticalAlign) {
  const imgBaseStyle = {
    pointerEvents: "none",
    position: "absolute",
    minWidth: "100%",
    minHeight: "100%",
    zIndex: -1,
  };
  const imgVerticalAlignMiddleStyle = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    margin: "auto",
  };
  if (imgVerticalAlign === "middle") {
    return { ...imgBaseStyle, ...imgVerticalAlignMiddleStyle };
  }
  if (imgVerticalAlign === "top") {
    return { ...imgBaseStyle };
  }
  throw Error(`Unknown imgVerticalAlign: '${imgVerticalAlign}'.`);
}

const Container = styled.div`
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const GrayBackground = styled.div`
  pointer-events: none;
  position: absolute;
  min-width: 100%;
  min-height: 100%;
  z-index: -1;
  background-color: ${(props) => props.theme.color.backgroundAlternate};
`;
